// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_YuV","left":"styles_left__2u3VP","desktopActions":"styles_desktopActions__15EE-","title":"styles_title__2_-AK"};